import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CountryModel } from '../global-data-models/country.model';
import { APIRoutes } from '../global-misc/api-routes';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CountryService {
  constructor(private http: HttpClient) { }

  async getAllCountries(): Promise<CountryModel[]> {
    const apiRoute = APIRoutes.COUNTRIES_ROUTE;
    const countriesResponse = await firstValueFrom(this.http.get<CountryModel[]>(apiRoute));
    return countriesResponse;
  }
}
